<app-status-tag
  [label]="statusLabel"
  [piIcon]="statusIcon?.piIcon"
  [iconSvgPath]="statusIcon?.iconSvgPath"
  [color]="statusSeverity">
</app-status-tag>
